import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const solutions = [
  { title: "Law Firm CRM", desc: "Track clients, cases, court dates, and billing in one system designed for legal practice." },
  { title: "OWL CaseMind AI", desc: "AI-powered legal research assistant that searches case law and drafts summaries in seconds." },
  { title: "Client Portal", desc: "Secure portal where clients can track case status, share documents, and communicate with your firm." },
  { title: "Legal PR & Visibility", desc: "SEO, content marketing, and social media designed for advocates and law firms." },
];

const Legal = () => (
  <StitchFeaturePage
    label="INDUSTRIES / LEGAL"
    title="Technology for"
    titleAccent="law firms."
    subtitle="From case management to courtroom visibility, systems built by teams who understand legal workflows."
    features={solutions}
    ctaLabel="BUILD FOR YOUR FIRM"
  />
);

export default Legal;
